import { useState, useEffect } from "react";
import { Button, Modal, message } from "antd";

import TaskForm from "../../../task/TaskForm";

import { updateTask } from "../../../../api/task";
import { cn, getQueryParamsString } from "../../../../lib/utils";
import dayjs from "dayjs";
import { endOfDay, isWithinInterval, startOfDay } from "date-fns";
import { useNavigate } from "react-router-dom";

const WeekEquipmentTaskTile = ({ task, className, onUpdate, date }) => {
  const [showTaskForm, setShowTaskForm] = useState(false);
  const [taskFormInstance, setTaskFormInstance] = useState();
  const [worklogs, setWorklogs] = useState([]);
  const navigate = useNavigate()

  useEffect(() => {
    let activeWorklogs = (task.workLogs || []).filter((w) => w.isActive);
    if (!activeWorklogs.length) return;

    const workLogsForTheDay = activeWorklogs.filter((w) => {
      const isWorkStartDaySame = dayjs(date).isSame(dayjs(w.startAt), "day");
      const isWorkEndDaySame = dayjs(date).isSame(dayjs(w.endAt), "day");
      const isDayInBetweenWorklogDates = isWithinInterval(date, {
        start: startOfDay(w.startAt),
        end: endOfDay(w.endAt),
      });

      return (
        isWorkStartDaySame || isWorkEndDaySame || isDayInBetweenWorklogDates
      );
    });

    setWorklogs(workLogsForTheDay);
  }, [task, date]);

  if (!task || !task.project || !task.project.client) return null;



  // Action functions for footer buttons
  const handleViewWorklogs = () => {
    const projectId = task.project.id
    const taskId = task.id
    const queryParams = getQueryParamsString({ taskId, view: "True" })

    navigate(`/worklogs?${queryParams}`)
  }

  const handleCreateWorklog = () => {
    const projectId = task.project.id
    const taskId = task.id
    const queryParams = getQueryParamsString({ projectId, taskId, create: "True" })

    navigate(`/worklogs?${queryParams}`)
  }

  const handleOk = async () => {
    const values = await taskFormInstance?.validateFields();
    const { workLogs, project, ...taskData } = task;

    let projectId = typeof (values.project) == "number" ? values.project : values.project.value;

    try {
      await updateTask({
        ...taskData,
        ...values,
        project: projectId,
      }).then(async () => {
        message.success("Task updated successfully");
        await onUpdate();
        setShowTaskForm(false);
      });
    } catch (error) {
      message.error("Failed to update task");
      console.error("Failed:", error);
    }
  }

  const handleCancel = () => setShowTaskForm(false)

  return (
    <div className="w-full">
      <div
        className={cn(
          "rounded-lg flex my-1 overflow-hidden cursor-pointer group hover:bg-gray-500 bg-sky-200 text-sky-700",
          worklogs.length && "bg-orange-200 text-orange-800",
          worklogs.some((w) => w.isDownloaded) && "bg-green-200 text-green-900",
          className
        )}
        onClick={() => setShowTaskForm(true)}
      >
        <div className="h-full w-1 group-hover:bg-orange-500"></div>
        <div className="p-2  flex flex-col justify-around">
          <p className="text-xs group-hover:text-white">
            {task.project.client.name}
          </p>
          <p className="text-xs font-semibold group-hover:text-white truncate overflow-ellipsis">
            {task.project.name}
          </p>
          <p className="font-light text-xs group-hover:text-white">
            {task.assignee.firstName + " " + task.assignee.lastName || ""}
          </p>
        </div>
      </div>
      <Modal
        title="Update Task"
        open={showTaskForm}
        // Keeping the onCancel and onOk so that the modal works with other cancel and ok events (Eg: pressing `Esc`)
        onCancel={handleCancel}
        onOk={handleOk}
        footer={<div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            {/* Always show the create worklog button */}
            <Button key="create-worklog" style={{ marginRight: 8 }} onClick={handleCreateWorklog}>
              Create Worklog
            </Button>

            {/* Show the download worklogs button only if there is any */}
            {task.workLogs.length > 0 &&
              <Button key="download" onClick={handleViewWorklogs}>
                View Worklogs ({task.workLogs.length})
              </Button>
            }

          </div>
          <div>
            <Button key="cancel" onClick={handleCancel} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button
              key="submit"
              type="primary"
              onClick={handleOk}
            >
              OK
            </Button>
          </div>
        </div>}
      >
        <TaskForm
          onFormInstanceReady={(instance) => {
            setTaskFormInstance(instance);
          }}
          initialValues={{
            ...task,
            project: { value: task.project.id, label: task.project.name },
          }}
        />
      </Modal>
    </div>
  );
};

export default WeekEquipmentTaskTile;
